export class Oui_TypeOuiNonNbCandidatReduitFNSSimple {

	public nbCandidat: number;

	public criteres: string;

	constructor() { 
		 		this.nbCandidat = 0;
		this.criteres = '';
 
	}
}
